import api from '../../plugins/api';

const getEquipmentsType = (params) => {
  return api.get('/api/crm/equipments/getEquipmentsType', params);
};

export default getEquipmentsType;
